import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2>
              Client <span style={{ color: "#49A950" }}>Brief</span>
            </h2>
            <p>
              Kush Me is a user-orientated app designed for people to connect
              with marijuana dispensaries located near them. Currently
              operational in 9 U.S states, where recreational use of marijuana
              has been legalized, Kush Me enables users to enjoy easy, reliable
              and hassle-free deliveries.
            </p>
            <h2>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#49A950" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#49A950" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#49A950" }}> MOBILE APPLICATION</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
